<template>
    <header
        class="header_style3 nav-stacked affix-top"
        data-spy="affix"
        data-offset-top="1"
    >
        <!-- Navigation -->
        <nav id="navigation_bar" class="navbar navbar-expand-lg">
            <div class="container">
                <div class="row header-row">
                    <div class="navbar-header">
                        <div class="logo">
                            <a href="/"
                                ><img
                                    src="/assets/images/logo/logo_light.png"
                                    class="img-fluid img-logo"
                                    alt="Logo-Redautos"
                            /></a>
                        </div>
                        <button
                            id="menu_slide"
                            data-target="#navigation"
                            aria-expanded="false"
                            data-toggle="collapse"
                            class="navbar-toggler"
                            type="button"
                        >
                            <i class="fa fa-bars"></i>
                        </button>
                    </div>
                    <div class="collapse navbar-collapse" id="navigation">
                        <ul class="nav navbar-nav ml-auto mt-0">
                            <li><a href="/compra_de_usados">Comprar</a></li>
                            <li><a href="/vender">Vender</a></li>
                            <li>
                                <a
                                    href="https://redautos.financiakarz.com/?utm_source=web&utm_medium=concesionario&utm_campaign=convenio&utm_term=web"
                                    target="_blank"
                                    >Financiar</a
                                >
                            </li>
                            <!--  <li><a href="/acercade">¿Por qué Redautos?</a></li> -->
                            <!-- <li><a href="/servicios">Servicios</a></li> -->
                            <li><a href="/contacto">Contacto</a></li>
                            <li class="dropdown">
                                <a
                                    href="#"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    aria-label="Abrir menú de usuario"
                                    class="text-right text-white"
                                >
                                    <i
                                        class="fa fa-user"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a href="/login">Iniciar Sesión</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <!-- <div class="quick-support">
                            <p>
                                <a href="mailto:servicioalcliente@redautos.com">
                                    <i
                                        class="fa fa-envelope-o"
                                        aria-hidden="true"
                                    ></i>
                                    servicioalcliente@redautos.com</a
                                >
                            </p>
                            |
                            <p>
                                <a href="https://wa.link/axe8kp" target="blank"
                                    ><i
                                        class="fa fa-whatsapp"
                                        aria-hidden="true"
                                    ></i>
                                    318 8274142</a
                                >
                            </p>
                        </div> -->
                    </div>
                </div>
            </div>
        </nav>
        <!-- Navigation end -->
    </header>
</template>

<script>
import config from "config/config.json";
export default {
    data() {
        return {
            logo:
                "https://brokcars-assets.s3.us-east-2.amazonaws.com" +
                config.logo_url
        };
    }
};
</script>

<style lang="scss">
img.img-fluid.img-logo {
    height: 50px !important;
}
i.fa.fa-user {
    font-size: 20px;
}
.quick-support {
    background: #000000 !important;
}
.quick-support::after {
    border-color: #000000 transparent transparent !important;
}
</style>
